import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { noWhitespaceValidator } from 'src/app/validators/no-whitespace.validator';

@Component({
  selector: 'app-object-type-list',
  templateUrl: './object-type-list.component.html',
  styleUrls: ['./object-type-list.component.css']
})
export class ObjectTypeListComponent implements OnInit {

  form: any | FormGroup
  editForm: any | FormGroup
  Data:any = []
  objectData: any = []
  singleStatusMaster: any= []
  deleteUomMasterId = ""
  page: number = 0;
  first: any = 0
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  statusTypes = [
    'MDSTATUS'
  ]

  isLoading: any = false
  typeId: any
  isSubmited: boolean = false;

  searchFilter: any = ""
  recordName: any = ""
  recordId: any = ""

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action
    this.cid = sessionStorage.getItem('cid')
    this.getAllTypeList()
    this.form = this.fb.group({
      typeName: ['',[Validators.required, noWhitespaceValidator]]
    })
    this.editForm = this.fb.group({
      name: [''],
      description: [''],
      type:[''],
    })
  }

  get groupListForm(){
    return this.form.get('groupList') as FormArray;
  }

  groupListObject(){
    return this.fb.group({
      "group": "",
    })
   }
  
   addGroupListArray(){
    this.groupListForm.push(this.groupListObject())
   }

   removeGroupListArray(index: number){
    this.groupListForm.removeAt(index)
   }

  onTableDataChange(event: any) {
    this.page = event.page + 1;
  }

  addObjectTypeMaster(){


    if(this.isSubmited){
      return
    }

    if(!this.form.valid){
      this.toastr.error("Please fill in all required fields")
      this.isSubmited = false
      return
    }

    this.isSubmited = true

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "typeName": this.form.get('typeName').value,
      "cid": Number(this.cid)
    }
    
    console.log(body)
    this.generic_service.addObjectTypeMaster(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getAllTypeList()
        this.form.reset()
        this.cancelModel()
        this.toastr.success(response.message)
        this.isSubmited = false

      },
      (error:any)=>{
        console.log(error)
        this.toastr.error(error.error.errors[0].description)
        this.isSubmited = false

      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    this.form.reset()
  }

  getAllTypeList(){
    this.isLoading = true
    this.generic_service.getAllTypeList().subscribe(
      (res:any)=> {
        console.log(res)
        this.objectData = res.response
        this.count = res.response.length
        this.isLoading = false
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }


// form.submit(function(){
//     form.submit(function(){
//         return false;
//     });
// });


deleteIdSelect(id:any,list: any){
  this.typeId = id
  this.recordId = list.objectTypeMasterId
  this.recordName = list.typeName
}
  
clearData(){
  this.recordId = "";
  this.recordName = "";
}

deleteType(){
  this.generic_service.deleteObjectTypeMaster(this.typeId).subscribe(
    (res:any)=>{
      console.log(res)
      this.getAllTypeList()
      this.toastr.success("Successfully Deleted")
      this.cancelModel()
      this.clearData()
    },
    (err:any)=> {
      console.log(err)
      this.toastr.error(err.errors[0].description)
    }
  )
}



  blockSpecialChars(event: KeyboardEvent): boolean {
    const allowedRegex = /^[a-zA-Z0-9 ]+$/;
    const key = event.key;

    if (key === 'Enter') {
      return true;
    }
    if (!allowedRegex.test(key)) {
      event.preventDefault(); // Block the character
      return false;
    }
    return true;
  }


  refreshAll(){
    this.page = 1
    this.first = 0
    this.searchFilter = ""
    this.getAllTypeList()
  }

  getAllTypeByWildSearch(){
    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.generic_service.getAllTypeByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.objectData = []
          this.count = 0
          return

        }
        this.objectData = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

}

